<template>
  <span
    v-if="isShowRange"
    class="floorplan-range"
    :style="{ transform: floorplanPosition }"
  >
    <span
      class="floorplan-range-inner"
      :style="{ transform: floorplanRotation }"
    />
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FloorplanRange',
  props: {
    ratio: {
      type: Number,
      default () {
        return 1
      }
    },
    ratioRfe: {
      type: Number,
      default () {
        return 1
      }
    },
    xOffset: {
      type: Number,
      default () {
        return 0
      }
    },
    yOffset: {
      type: Number,
      default () {
        return 0
      }
    },
    scale: {
      type: Number,
      default () {
        return 1
      }
    }
  },

  computed: {
    ...mapGetters([
      'currentPanorama',
      'krpanoLookAtH',
      'krpanoXOffset'
    ]),

    floorplanPosition () {
      if (this.currentPanorama.position) {
        const x = (this.currentPanorama.position.x + 12.85 / this.ratioRfe) * this.ratio + this.xOffset - 10
        const y = (this.currentPanorama.position.y + 15.00 / this.ratioRfe) * this.ratio + this.yOffset - 10
        return `translate(${x}px, ${y}px) scale(${this.scale})`
      }
      return ''
    },

    floorplanRotation () {
      if (this.currentPanorama.panoramaRotation) {
        const rotation = this.currentPanorama.floorplanRotation || 0
        const panoramaRotationY = this.currentPanorama.panoramaRotation.y || 0
        const cameraMoving = this.krpanoLookAtH - this.krpanoXOffset + panoramaRotationY
        return `rotateZ(${rotation + cameraMoving}deg)`
      }
      return ''
    },

    isShowRange () {
      return !this.currentPanorama.floorplanHidden
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/common/extends'

.floorplan-range {
  transition: transform .8s ease-out
  position: absolute
  display: flex
  width: 20px
  height: 20px
  border-radius: 50%
  opacity: .9
  pointer-events: none
}

.floorplan-range-inner {
  @extend .bg-center
  $w = 86px
  $h = 50px
  bg-size($w, $h)
  position: absolute
  margin-left: -33px
  margin-top: -40px
  background-image: url('img/range.png')
  transform-origin: 50% 100%
  pointer-events: none
}
</style>
